import React from 'react'
import { Vendor } from '../types'
import { Link, useNavigate } from 'react-router-dom'
import KratomLeafIcon from './KratomLeafIcon'
import VendorTypeBadges from './VendorTypeBadges'

interface VendorCardProps {
  vendor: Vendor
}

export default function VendorCard({ vendor }: VendorCardProps) {
  const navigate = useNavigate()
  
  const handleCardClick = (e: React.MouseEvent) => {
    // Don't navigate if clicking on action buttons
    if ((e.target as HTMLElement).closest('.vendor-actions')) {
      return
    }
    navigate(`/vendor/${vendor.id}`)
  }
  
  return (
    <div className="vendor-card vendor-card-clickable" onClick={handleCardClick}>
      <div className="vendor-card-header">
        <div className="vendor-info">
          <h3 className="vendor-name">
            {vendor.name}
            {vendor.verified && (
              <span className="verified-badge">
                ✓
              </span>
            )}
          </h3>
          <VendorTypeBadges specialties={vendor.specialties} size="small" />
          <p className="vendor-location">{vendor.location}</p>
        </div>
        <div className="vendor-rating">
          <span className="rating-display">{vendor.rating}/5</span>
          <span className="review-count">({vendor.reviewCount} reviews)</span>
        </div>
      </div>
      
      <p className="vendor-description">{vendor.description}</p>
      
      <div className="vendor-specialties">
        <strong>Specialties:</strong>
        <div className="specialty-tags">
          {vendor.specialties.slice(0, 3).map((specialty, index) => (
            <span key={index} className="specialty-tag">{specialty}</span>
          ))}
          {vendor.specialties.length > 3 && (
            <span className="specialty-tag">+{vendor.specialties.length - 3} more</span>
          )}
        </div>
      </div>
      
      <div className="vendor-details">
        <div className="detail-item">
          <strong>Founded:</strong> {vendor.founded}
        </div>
        <div className="detail-item">
          <strong>Shipping:</strong> {vendor.shippingRegions.join(', ')}
        </div>
        <div className="detail-item">
          <strong>Payment:</strong> {vendor.paymentMethods.join(', ')}
        </div>
      </div>
      
      <div className="vendor-actions">
        <a 
          href={vendor.website} 
          target="_blank" 
          rel="noopener noreferrer"
          className="visit-website-btn"
        >
          Visit Website
        </a>
        <Link 
          to={`/reviews?vendor=${vendor.id}`}
          className="view-reviews-btn"
        >
          View Reviews ({vendor.reviewCount})
        </Link>
      </div>
    </div>
  )
}